import bindAllOfThis from 'src/utils/BindThisHelper';
import { PhaserGeneralGameObjectType, TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { EndGameScene } from './EndGameScene';
import { Cart } from '../objects/Cart';
import { createMemoryHistory } from 'history';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    carts: Cart[];

    index: number;
    wheel: Phaser.GameObjects.Sprite;

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/ride_mechanic.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/pkr_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameRideMechanic.png"), require("src/assets/qci/atlas/gameRideMechanic.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.carts = [];
        this.index = 2;
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);

        var struts = this.add.image(0, 0, 'assets', 'struts').setOrigin(0);
        struts.setDepth(2);

        this.createZones();
        this.createCarts();
        this.registerEvents();
    }

    createZones() {
        this.map.getObjectLayer("Zones").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "brokenWheel") {
                this.wheel = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "brokenWheel");
                this.wheel.setDepth(1);
            }
            else {
                var zone = this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
                zone.setRectangleDropZone(ob.width, ob.height);
                // this.add.graphics()
                //     .strokeRect(zone.x - zone.input.hitArea.width / 2, zone.y - zone.input.hitArea.height / 2, zone.input.hitArea.width, zone.input.hitArea.height);
            }
        });
    }

    createCarts() {
        this.map.getObjectLayer("Carts").objects.forEach((ob: TiledGameObject) => {
            var cart = new Cart(this, ob);
            this.carts.push(cart);
        });
    }

    registerEvents(): void {
        this.input.dragDistanceThreshold = 10;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, cart: Cart) => {
            this.children.bringToTop(cart);
            pointer.x = cart.x;
            pointer.y = cart.y;
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, cart: Cart, dragX: number, dragY: number) => {
            cart.x = pointer.x;
            cart.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, cart: Cart, dropped: boolean) => {
            if (!dropped) {
                // Put back
                cart.x = cart.input.dragStartX;
                cart.y = cart.input.dragStartY;
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, cart: Cart, zone: Phaser.GameObjects.Zone) => {
            this.drop(cart, zone);
        });

    }

    drop(cart: Cart, zone: Phaser.GameObjects.Zone) {
        this.children.moveDown(cart);

        cart.isFixed = true;
        cart.input.enabled = false;
        zone.input.enabled = false;

        cart.setDepth(0.5);

        cart.x = zone.x;
        cart.y = zone.y + 30;

        this.isGameOver();
    }

    isGameOver(): boolean {
        var cart: Cart;

        for (cart of this.carts) {
            if (!cart.isFixed) {
                return false;
            }
        }

        this.carts.forEach((c: Cart) => c.setVisible(false));
        this.input.enabled = false;

        // Animate ferris wheel spinning
        this.anims.create({
            key: 'spin',
            frames: this.anims.generateFrameNames("assets", { prefix: "wheelSpin", start: 1, end: 12 }),
            frameRate: 2,
        });
        this.wheel.play('spin');

        // End the game
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 3500);
    }
}



// WEBPACK FOOTER //
// ./src/games/RideMechanicGame/scenes/MainScene.ts